import { create } from 'zustand';

import { closeOtherRightSlotSurfaces, registerRightSlotCloser } from './_right-slot-mutex';

const STORAGE_PREFIX = 'mora.hub.open.';

interface ProjectHubStore {
  isOpen: boolean;
  setOpen: (open: boolean, planId?: string | null) => void;
  toggle: (planId?: string | null) => void;
  hydrateFromPlan: (planId: string | null) => void;
  reset: () => void;
}

export const useProjectHubStore = create<ProjectHubStore>((set, get) => ({
  isOpen: false,

  setOpen: (open, planId) => {
    if (open) closeOtherRightSlotSurfaces('project-hub');
    set({ isOpen: open });
    if (planId) {
      try {
        localStorage.setItem(STORAGE_PREFIX + planId, open ? '1' : '0');
      } catch {
        /* ignore quota errors — closed-when-it-should-be-open default is acceptable */
      }
    }
  },

  toggle: (planId) => {
    const next = !get().isOpen;
    get().setOpen(next, planId);
  },

  hydrateFromPlan: (planId) => {
    if (!planId) {
      set({ isOpen: false });
      return;
    }
    try {
      const stored = localStorage.getItem(STORAGE_PREFIX + planId);
      const isOpen = stored === '1';
      if (isOpen) closeOtherRightSlotSurfaces('project-hub');
      set({ isOpen });
    } catch {
      set({ isOpen: false });
    }
  },

  reset: () => set({ isOpen: false }),
}));

registerRightSlotCloser('project-hub', () => useProjectHubStore.getState().reset());

if (typeof window !== 'undefined') {
  (window as any).__useProjectHubStore = useProjectHubStore;
}
